import { HttpClient } from 'aurelia-http-client';
import { AuthService } from 'services/authService';
import environment from './environment';
import raf from 'raf';
import './resources/facebook-pixel';

export function configure(aurelia) {

  aurelia.container.makeGlobal();
  aurelia.use
    .standardConfiguration()
    .feature('resources')
    .plugin('aurelia-bootstrap-datetimepicker', config => {
       // config.extra.bootstrapVersion = 4;
        config.extra.withDateIcon = false;
        // you can also change the button class, default is shown below
       // config.extra.buttonClass = 'btn btn-outline-secondary';
    }).plugin('aurelia-validation');

  if (environment.debug) {
    aurelia.use.developmentLogging();
  }

  if (environment.testing) {
    aurelia.use.plugin('aurelia-testing');
  }

  raf.polyfill();
  configureContainer(aurelia.container);
  aurelia.start().then(() => {

    aurelia.setRoot();

  });


  Promise.config({ warnings: false });

  aurelia.use.plugin('aurelia-google-analytics', config => {

    this.site_url = window.site_url;
    console.log(this.site_url);

    if(this.site_url == "https://app.magnfi.com")
    {
      config.init('UA-109744424-1');
      config.attach({
        logging: {
          // Set to `true` to have some log messages appear in the browser console.
          enabled: true
        },
        pageTracking: {
          // Set to `false` to disable in non-production environments.
          enabled: true,
          // Optional. By default it gets the title from payload.instruction.config.title.
          getTitle: (payload) => {
            // For example, if you want to retrieve the tile from the document instead override with the following.
            return document.title;
          },
          // Optional. By default it gets the URL fragment from payload.instruction.fragment.
          getUrl: (payload) => {
            // For example, if you want to get full URL each time override with the following.
            return window.location.href;
          }
        },
        clickTracking: {
          // Set to `false` to disable in non-production environments.
          enabled: true,
          // Optional. By default it tracks clicks on anchors and buttons.
          filter: (element) => {
            // For example, if you want to also track clicks on span elements override with the following.
            return element instanceof HTMLElement &&
              (element.nodeName.toLowerCase() === 'a' ||
                element.nodeName.toLowerCase() === 'button');
          }
        },
        exceptionTracking: {
          // Set to `false` to disable in non-production environments.
          enabled: true
        }
      });
    }  

  });
  
}

function configureContainer(container) {


  let http = new HttpClient();
  http = http.configure(config => {
    config
      .withInterceptor({
        request(message) {
          return message;
        },

        requestError(error) {
          throw error;
        },

        response(message) {

          if (message.statusCode==301){
            let response=JSON.parse(message.response)
            if(response.expired){
              window.location.href='/#/visitor/trialExpired';
            }
          }

          return message;
        },

        responseError(error) {
          if (error.statusCode == 401) {
            let authService = container.get(AuthService);
            authService.logout();
            return error;
          }
          else {
            return error;
          }
        }
      });


  });

  container.registerInstance(HttpClient, http);
}